import { gql } from '@apollo/client';
import { USER_FRAGMENTS } from '@graphql/fragments/userFragment';

export const REQUEST_MAGIC_LINK_MUTATION = gql`
  mutation RequestMagicLink($email: String!) {
    requestMagicLink(input: { email: $email }) {
      emailSent
      message
      errors {
        code
        message
        field
      }
    }
  }
`;

export const VERIFY_MAGIC_LINK_MUTATION = gql`
  mutation VerifyMagicLink($input: VerifyMagicLinkInput!) {
    verifyMagicLink(input: $input) {
      accessToken
      refreshToken
      user {
        ...UserFields
      }
      errors {
        code
        message
        field
      }
    }
  }
  ${USER_FRAGMENTS}
`;
